export default {
  dashboardMessage: 'dashboard.mainText',
};
